import { render, staticRenderFns } from "./table.vue?vue&type=template&id=f1774c8a&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=f1774c8a&prod&scoped=true&lang=css"
import style1 from "./table.vue?vue&type=style&index=1&id=f1774c8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1774c8a",
  null
  
)

export default component.exports